import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';

import { OomphService } from '../../services/oomph/oomph.service';

@Component({
  selector: 'sn-oomph',
  templateUrl: './oomph.component.html',
  styleUrls: ['./oomph.component.css']
})
export class OomphComponent implements OnInit {

  private currentScreenSizeSubject = new ReplaySubject<any>(1);
  public currentScreenSize = this.currentScreenSizeSubject.asObservable();

  constructor(
    public elementRef: ElementRef,
    public oomphService: OomphService
  ) {
    this.onResize(null);
  }

  ngAfterViewInit(){
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'black';
    this.elementRef.nativeElement.ownerDocument.body.style.color = 'white';
  }

  setCurrentScreenSize(size) {
    this.currentScreenSizeSubject.next(size);
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    let screen_size: any = { width: window.innerWidth, height: window.innerHeight };
    this.setCurrentScreenSize(screen_size);
  }

  ngOnInit() {
    //this.ngOnInit();
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oomph.component.ts